var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teacherSection"},[_c('Headline'),_c('Headline2'),_c('Schedule'),_c('LessonDevelopment'),_c('Collaboration'),_c('Templates'),_c('LearningStandards'),_c('SharePlans'),_c('MuchMore'),_c('Signup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }